import { createBrowserRouter } from 'react-router-dom';
import App from '../App.jsx';
import CenterHome from '../pages/CenterHome/CenterHome.jsx';

const routes = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [{ path: 'center-home', element: <CenterHome /> }],
  },
]);

export default routes;
